export const address = "https://the-arqam-school-backend.herokuapp.com";
// export const address = "http://192.168.100.11:8000";